import React from 'react';

const ContactInfo = () => {
  return (
    // <div className="w-full max-w-[1280px] mx-auto px-4 py-[60px] md:py-[80px]">
    //   <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 lg-gap-8">
        
    //     {/* Phone Numbers Card */}
    //     <div className="w-full max-w-[410px] mx-auto bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] py-[29px] px-[29px] md:py-[30px] lg:py-[43px] lg:px-[55px] md:px-[30px] hover:shadow-lg transition-shadow duration-300">
    //       <h3 className="text-[20px] md:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[20px] whitespace-nowrap">
    //         Available Phone Numbers
    //       </h3>
    //       <p className="opacity-40 text-[18px]">
    //         +91 040-2781 1583,<br />
    //         +91 040-2781 6958
    //       </p>
    //     </div>

    //     {/* Email Card */}
    //     <div className="w-full max-w-[410px] mx-auto bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] py-[31px] px-[29px] md:py-[30px] lg:py-[43px] lg:px-[55px] md:px-[25px] hover:shadow-lg transition-shadow duration-300">
    //       <h3 className="text-[20px] md:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[20px]">
    //         Email Us
    //       </h3>
    //       <p className="opacity-40 text-[18px]">
    //         agastyaagro@yahoo.com
    //       </p>
    //     </div>

    //     {/* Location Card */}
    //     <div className="w-full max-w-[410px] mx-auto bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] py-[22px] px-[29px] md:py-[57px] md:px-[55px] lg:py-[43px] lg:px-[55px] md:px-[25px] hover:shadow-lg transition-shadow duration-300">
    //       <h3 className="text-[20px] md:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[20px]">
    //         Our Location
    //       </h3>
    //       <p className="opacity-40 text-[18px]">
    //         Corp. Off: D.No. 9-1-119/1, Flat No. 711, 7th Floor, 
    //         Amsri Eden Square, Secunderabad - 500 003.
    //       </p>
    //     </div>
    //   </div>
      
    // </div>


    <div className="container-custom px-4 md:px-0 py-[60px] md:py-[80px]">
  <div className="flex flex-col md:flex-row flex-wrap gap-6 lg:gap-[25px] items-center md:items-start justify-center">
    
    {/* Phone Numbers Card */}
    <div className="w-full max-w-[358px] h-[160px] md:max-w-[410px] md:h-[200px] bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] p-[20px] md:p-[30px] lg:p-[40px] hover:shadow-lg transition-shadow duration-300">
      <h2 className="text-[18px] md:text-[20px] lg:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[12px] md:mb-[20px]">
        Available Phone Numbers
      </h2>
      <p className="opacity-40 text-[16px] md:text-[18px]">
        <a href="tel:+914027811583" className="hover:underline">+91 040-2781 1583</a>,<br />
        <a href="tel:+914027816958" className="hover:underline">+91 040-2781 6958</a>
      </p>
    </div>

    {/* Email Card */}
    <div className="w-full max-w-[358px] h-[160px] md:max-w-[410px] md:h-[200px] bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] p-[20px] md:p-[30px] lg:p-[40px] hover:shadow-lg transition-shadow duration-300">
      <h2 className="text-[18px] md:text-[20px] lg:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[12px] md:mb-[20px]">
        Email Us
      </h2>
      <p className="opacity-40 text-[16px] md:text-[18px]">
        <a href="mailto:agastyaagro@yahoo.com" className="hover:underline">agastyaagro@yahoo.com</a>
      </p>
    </div>

    {/* Location Card */}
    <div className="w-full max-w-[358px] h-[160px] md:max-w-[410px] md:h-[200px] bg-[#F9F9FB] rounded-[24px] border border-[#BABABA] p-[20px] md:p-[30px] lg:p-[40px] hover:shadow-lg transition-shadow duration-300">
      <h2 className="text-[18px] md:text-[20px] lg:text-2xl font-[LTWave] font-medium text-[#1C1C1C] mb-[12px] md:mb-[20px]">
        Our Location
      </h2>
      <p className="opacity-40 text-[16px] md:text-[18px] leading-snug">
        Corp. Off: D.No. 9-1-119/1, Flat No. 711,<br />
        7th Floor, Amsri Eden Square,<br />
        Secunderabad - 500 003.
      </p>
    </div>

  </div>
</div>

  );
};

export default ContactInfo;
